import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../config/globalVariables";

import { setupCache } from "axios-cache-interceptor";
import { axiosRequestMiddleware } from "../middleware/axiosRedirect";

const candidateClient = axios.create({
  baseURL: `${API_GATEWAY}${PR_DEP}/candidate`,
});
candidateClient.interceptors.request.use(axiosRequestMiddleware);
const cacheCandidateClient = setupCache(candidateClient);
cacheCandidateClient.interceptors.response.use(
  (response) => {
    if (
      response.status >= 200 &&
      response.status < 300 &&
      response.config.method !== "get"
    ) {
      cacheCandidateClient.storage.data = {};
    }
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);
export { candidateClient, cacheCandidateClient };
